import { render, staticRenderFns } from "./SimilarStartups.vue?vue&type=template&id=5282a73a&scoped=true&"
import script from "./SimilarStartups.vue?vue&type=script&lang=js&"
export * from "./SimilarStartups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5282a73a",
  null
  
)

export default component.exports